import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import bg1 from "../../assets/images/Banner_imgs/bannerImg.jpg";
import OSIcon from "../../assets/images/omniscientiaLogoWithTitle.png";
import PUIcon from "../../assets/images/PUlogo.png";
import PageContainer from "../../components/container/Container";
import { FiArrowRight, FiCheck } from "../../assets/icons/vander";

// Testimonial data
import anant from "../../assets/images/clienttest/Anantkumar.jpg";
import andre from "../../assets/images/clienttest/Andre-Cardozo.png";
import smart from "../../assets/images/clienttest/Samraat-Sardesai.png";
import sandeep from "../../assets/images/clienttest/Sandeep-mehra.jpg";
import navdeep from "../../assets/images/clienttest/navdeep.jpeg";
import shiva from "../../assets/images/clienttest/shivaGaur.png";

export default function IndexCorporate() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const scrollContainerRef = useRef(null);

  // Auto-scroll functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => {
        const next = (prev + 1) % testimonialData.length;
        scrollToSlide(next);
        return next;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // Scroll to specific slide
  const scrollToSlide = (slideIndex) => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const cardWidth = 350 + 24; // card width + gap
      container.scrollTo({
        left: slideIndex * cardWidth,
        behavior: 'smooth'
      });
    }
  };

  // Navigation functions
  const nextSlide = () => {
    const next = (currentSlide + 1) % testimonialData.length;
    setCurrentSlide(next);
    scrollToSlide(next);
  };

  const prevSlide = () => {
    const prev = currentSlide === 0 ? testimonialData.length - 1 : currentSlide - 1;
    setCurrentSlide(prev);
    scrollToSlide(prev);
  };

  const servicesData = [
    {
      icon: OSIcon,
      subtitle: "Computer Vision Platform",
      link: "https://omniscientia.codeelan.com/",
      desc: "Powered by cutting-edge neural networks and sophisticated image processing techniques, our platform enables businesses to automate visual tasks with unmatched accuracy, efficiency, and scalability.",
      features: ["Real-time Detection", "High Accuracy", "Scalable Solution"]
    },
    {
      icon: PUIcon,
      subtitle: "Test Automation Platform",
      link: "https://perfectus.codeelan.com/",
      desc: "Revolutionize Testing Across Web, API, Mobile & Performance with our comprehensive automation platform.",
      features: ["Multi-platform Testing", "API Automation", "Performance Testing"]
    },
  ];

  const statsData = [
    { number: "500+", label: "Projects Delivered" },
    { number: "50+", label: "Happy Clients" },
    { number: "24/7", label: "Support Available" },
    { number: "99%", label: "Client Satisfaction" }
  ];

  const testimonialData = [
    {
      image: smart,
      desc: '"We engaged CodeElan Technologies for QA for our product IdeaBridge. It has been a great experience working with them. Without a doubt, we are happy to recommend CodeElan Technologies for their work ethics and professionalism."',
      name: "Samraat Sardesai",
      title: "(Co-Founder, Plus Innovations)",
    },
    {
      image: sandeep,
      desc: '"CodeElan Technologies team as they were very good in understanding existing application and suggested best automation framework for the project. I highly recommend CodeElan Technologies team and would collaborate with them for future projects."',
      name: "Sandeep Mehra",
      title: "(Director, AcmeMinds Private Limited)",
    },
    {
      image: anant,
      desc: '"CodeElan Technologies has been our testing partner for the last couple of years and has been an integral part of our team. They are our go-to team when it comes to quality testing."',
      name: "Anant Kumar",
      title: "(Founder and Owner, Banyan Tree)",
    },
    {
      image: andre,
      desc: '"I am writing to recommend the services of CodeElan Technologies. CodeElan testing team has been working for our company for the last 3 years as our Testing Team. I am confident in recommending CodeElan Technologies."',
      name: "Andre Cardozo",
      title: "(Co-founder and CTO, Plus Innovations)",
    },
    {
      image: navdeep,
      desc: `"Their AI solutions transformed our operations—seamless integration, real-time insights, and unmatched efficiency. A true game-changer!"`,
      name: "Navdeep Shrivastav",
      title: "(VP, BO, Sierra Cloud)",
    },
    {
      image: shiva,
      desc: '"Innovative, reliable, and forward-thinking. Their tech expertise and AI capabilities exceeded our expectations and drove measurable results."',
      name: "Shiva Gaur",
      title: "(Advocate, Strategic Advisor to MP)",
    },
  ];

  return (
    <>
      <PageContainer
        title={"CodeElan Technologies - Where AI Makes Real-World Impact"}
        description={"This page is the home page for CodeElan technologies."}
      >
        {/* Hero Section */}
        <section className="hero-section">
          <div className="hero-background">
            <div className="hero-overlay"></div>
          <div className="container">
              <div className="row align-items-center min-vh-100">
                <div className="col-lg-8 mx-auto text-center">
                  <div className="hero-content">
                    {/* Simple Background Accent */}
                    <div className="hero-accent"></div>
                    
                    {/* Clean Title */}
                    <h1 className="hero-title">
                      Where <span className="text-primary">AI</span> Makes 
                      <br />Real-World Impact
                    </h1>
                    
                    {/* Clean Subtitle */}
                    <p className="hero-subtitle">
                      Empowering businesses with cutting-edge AI/ML solutions, computer vision technology, 
                      and comprehensive testing automation to drive innovation and efficiency.
                    </p>
                    
                    {/* Simple Buttons */}
                    <div className="hero-buttons">
                      <Link to="/contactus" className="btn btn-primary btn-lg">
                        Get Started
                        <FiArrowRight className="ms-2" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="section-sm">
          <div className="container">
            <div className="row">
              {statsData.map((stat, index) => (
                <div key={index} className="col-lg-3 col-md-6 mb-4">
                  <div className="stat-card text-center">
                    <h2 className="stat-number text-primary fw-bold">{stat.number}</h2>
                    <p className="stat-label text-secondary">{stat.label}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="section cta-section">
          <div className="container">
            <div className="row justify-content-center mb-5">
              <div className="col-lg-8 text-center">
                <h2 className="section-title">Our Core Platforms</h2>
                <p className="section-subtitle">
                  Discover our innovative solutions that are transforming industries through AI and automation
                </p>
              </div>
            </div>
            <div className="row">
              {servicesData.map((service, index) => (
                <div key={index} className="col-lg-6 mb-4">
                  <div className="service-card">
                    <div className="service-header">
                      <img src={service.icon} alt="Platform Logo" className="service-logo" />
                      <div className="service-subtitle-wrapper">
                        <p className="service-subtitle">{service.subtitle}</p>
                      </div>
                    </div>
                    <p className="service-description">{service.desc}</p>
                    <div className="service-features">
                      {service.features.map((feature, idx) => (
                        <div key={idx} className="feature-item">
                          <FiCheck className="feature-icon" />
                          <span>{feature}</span>
                        </div>
                      ))}
                    </div>
                    <div className="service-action">
                      <a href={service.link} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary">
                        Learn More
                        <FiArrowRight className="ms-2" />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="section">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="about-content">
                  <h2 className="section-title">About CodeElan</h2>
                  <p className="section-subtitle">
                    We are a technology company specializing in AI/ML, computer vision, and software testing automation. 
                    Our mission is to help businesses leverage cutting-edge technology to solve real-world problems.
                  </p>
                  <div className="about-features">
                    <div className="feature-item">
                      <FiCheck className="feature-icon" />
                      <span>Expert AI/ML Solutions</span>
                    </div>
                    <div className="feature-item">
                      <FiCheck className="feature-icon" />
                      <span>Computer Vision Technology</span>
                    </div>
                    <div className="feature-item">
                      <FiCheck className="feature-icon" />
                      <span>Comprehensive Testing</span>
                    </div>
                    <div className="feature-item">
                      <FiCheck className="feature-icon" />
                      <span>Cloud & DevOps Services</span>
                  </div>
                  </div>
                  <Link to="/aboutus" className="btn btn-primary">
                    Learn More About Us
                    <FiArrowRight className="ms-2" />
                  </Link>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-image">
                  <img src={bg1} alt="About CodeElan" className="img-fluid rounded-lg shadow-lg" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="section cta-section testimonials-section">
          <div className="container position-relative">
            <div className="row justify-content-center mb-5">
              <div className="col-lg-8 text-center">
                <h2 className="section-title">What Our Clients Say</h2>
                <p className="section-subtitle">
                  Hear from our satisfied clients about their experience working with CodeElan
                </p>
              </div>
                          </div>
            
            {/* Navigation Arrows */}
            <button className="testimonial-nav-btn testimonial-nav-prev" onClick={prevSlide}>
              <i className="mdi mdi-chevron-left"></i>
            </button>
            <button className="testimonial-nav-btn testimonial-nav-next" onClick={nextSlide}>
              <i className="mdi mdi-chevron-right"></i>
            </button>
            
            <div className="testimonials-scroll-container" ref={scrollContainerRef}>
              <div className="testimonials-row">
                {testimonialData.map((testimonial, index) => (
                  <div key={index} className="testimonial-item">
                    <div className="testimonial-card">
                      <div className="testimonial-content">
                        <div className="quote-icon">
                          <i className="mdi mdi-format-quote"></i>
                        </div>
                        <p className="testimonial-text">{testimonial.desc}</p>
                      </div>
                      <div className="testimonial-author">
                        <img src={testimonial.image} alt={testimonial.name} className="author-avatar" />
                        <div className="author-info">
                          <h5 className="author-name">{testimonial.name}</h5>
                          <p className="author-title">{testimonial.title}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            
            {/* Slide Indicators */}
            <div className="testimonial-indicators">
              {testimonialData.map((_, index) => (
                <button
                  key={index}
                  className={`indicator-dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => {
                    setCurrentSlide(index);
                    scrollToSlide(index);
                  }}
                />
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="section cta-section">
          <div className="container">
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                <h2 className="section-title">Ready to Transform Your Business?</h2>
                <p className="section-subtitle">
                  Let's discuss how our AI and automation solutions can help you achieve your goals
                </p>
                <div className="cta-buttons">
                  <Link to="/contactus" className="btn btn-light btn-lg">
                    Get In Touch
                    <FiArrowRight className="ms-2" />
                  </Link>
                  <Link to="/case-studies" className="btn btn-outline-light btn-lg ms-3">
                    View Case Studies
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </PageContainer>
    </>
  );
}
